import React from 'react';
import { Container, Card, CardHeader, Typography, CardContent, TextField, withStyles, CardActions, Button } from '@material-ui/core';
import { login } from '../../Helpers/UserHelpers';
import { Redirect } from 'react-router-dom';

const styles = theme => ({
    root: {
        marginTop: theme.spacing(4)
    },
    textField: {
        marginBottom: theme.spacing(3),
        '&:last-child': {
            marginBottom: 0
        }
    }
})

class Login extends React.Component {
    state = {
        creds: {
            email: '',
            password: '',
        },
        error: null,
        redirectLink: null,
    }

    handleChange = (e) => {
        let creds = this.state.creds;
        creds[e.target.id] = e.target.value
        this.setState({ creds });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        login(this.state.creds)
            .then(redirectLink => this.setState({ redirectLink }))
            .catch(error => this.setState({ error }));
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                {this.state.redirectLink ? <Redirect to={this.state.redirectLink} /> : null }
                <Container maxWidth="sm">
                    <Card className={classes.root}>
                        <form onSubmit={this.handleSubmit}>
                            <CardHeader title="Login" />
                            <CardContent>
                                <Typography variant="body1" color="error">{this.state.error ? this.state.error : ''}</Typography>
                                <TextField
                                    id="email"
                                    placeholder="Email"
                                    fullWidth
                                    required
                                    className={classes.textField}
                                    value={this.state.creds.email}
                                    onChange={this.handleChange}/>
                                <TextField
                                    id="password"
                                    type="password"
                                    placeholder="Password"
                                    fullWidth
                                    required
                                    className={classes.textField}
                                    value={this.state.creds.password}
                                    onChange={this.handleChange}/>
                            </CardContent>
                            <CardActions>
                                <Button type="submit" variant="contained" color="primary">Login</Button>
                            </CardActions>
                        </form>
                    </Card>
                </Container>
            </div>
        )
    }
}

export default withStyles(styles)(Login);